import React from 'react';
import styled from 'styled-components';
import { Flex, Image } from 'antd';
import { colors, fonts } from '../assets/constStyles';

const IconStyled = styled(Image)`
  width: auto;
  max-height: 70px;
  object-fit: contain;
  
  @media (max-width: 768px) {
    max-height: 60px;
    width: auto;
    object-fit: contain;
  }
`;

const H3Styled = styled.h3`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 30px;
  font-family: ${fonts.font2};
  color: ${colors.colorMutedYellow};
  text-align: center;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

const DivStyled = styled.div`
  padding: 20px;
  position: relative;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const BlockNationalPartners: React.FC = () => (
    <DivStyled>
        <H3Styled>AWMAC's NATIONAL PARTNERS</H3Styled>
        <Flex gap={50} align={'center'} justify={'space-between'}>
            <a href={'https://hardwoods-inc.com/'} target="_blank" rel="noopener noreferrer">
                <IconStyled src={'../img/hardwoods.png'} preview={false}/>
            </a>
            <a href={'https://www.hettich.com/'} target="_blank" rel="noopener noreferrer">
                <IconStyled src={'../img/hettich.png'} preview={false}/>
            </a>
            <a href={'https://www.richelieu.com/ca/en/'} target="_blank" rel="noopener noreferrer">
                <IconStyled src={'../img/richelieu.png'} preview={false}/>
            </a>
        </Flex>
    </DivStyled>
);
